<div class="text-center d-block card-footer">
  <ng-content></ng-content>
</div>
